import { MouseEventHandler } from 'react'
import { IconName } from '../../types/icons'
import { ReactSVG } from 'react-svg'

export interface IconSvgProps {
	icon: IconName
	className?: string
	width?: number
	height?: number
	title?: string
	onClick?: MouseEventHandler<any>
}

export function IconSvg({ icon, width, height, title, onClick, ...props }: IconSvgProps) {
	return (
		<ReactSVG
			{...props}
			src={`/images/common/icon-svg/icon-${icon}.svg`}
			onClick={onClick}
			style={{
				cursor: onClick ? 'pointer' : 'default',
			}}
			beforeInjection={svg => {
				let style = ''
				if (width) {
					style += `width: ${width}px;`
				}
				if (height) {
					style += `height: ${height}px;`
				}

				svg.setAttribute('style', style)
			}}
			title={title}
		/>
	)
}
